// extracted by mini-css-extract-plugin
module.exports = {"container":"RoutableTabs_container__3GBnU"};